module.exports = __webpack_public_path__ + "static/media/window-restore.0223564c.svg";